// extracted by mini-css-extract-plugin
export var actions = "_sw-4";
export var item = "_sw-1";
export var price = "_sw-3";
export var quantity = "_sw-2";
export var table = "_sw-0";